import React from 'react';
import { ModelPreloader } from 'client/data/luckdragon/redux/model-preloader';
import { CmsModel } from 'client/data/models/cms';
import { PageModel } from 'client/data/models/page';
import { parseContent } from 'client/data/cms/content';
import { getHeroContentImageSources } from 'site-modules/editorial/components/hero-content/2027/hero-content-sources';
import { EdmundsTopRatedDecorator } from 'site-modules/shared/pages/decorators/edmunds-top-rated';
import { TOP_RATED } from 'site-modules/shared/constants';
import {
  getTopRatedIndexContentPath,
  getTopRatedThemeContentPath,
} from 'site-modules/shared/utils/top-rated/content-path';
import { getTopRatedIndexSeoObject } from 'site-modules/editorial/pages/top-rated/seo';
import { decoratorParams } from 'site-modules/shared/pages/decorators/decorator-params';

function getPageName(year, isDefaultYear) {
  return isDefaultYear ? TOP_RATED : `${TOP_RATED}_${year}`;
}

export const getPageOptions = ({ year, isDefaultYear, pageTemplate: PageTemplate, chunkName }) => ({
  name: getPageName(year, isDefaultYear),
  category: 'top_rated',
  adsCustomTargeting: {
    sect1: 'toprated',
  },
  chunkName,
  preload: store => {
    const preloader = new ModelPreloader(store);
    const articlePath = getTopRatedIndexContentPath(year);
    const themePath = getTopRatedThemeContentPath(year);
    preloader.resolve(`content["${articlePath}"]`, CmsModel);
    preloader.resolve(`content["${themePath}"]`, CmsModel);

    return preloader.load().then(modelState => {
      if (year !== '2027') return modelState;

      const content = parseContent(modelState.get(`content["${articlePath}"]`, CmsModel));
      const heroContent = content.child('hero-content');
      const heroImageAssets = getHeroContentImageSources(heroContent, 'Cars')
        .map(({ avif, media }) => ({
          href: avif,
          as: 'image',
          type: 'image/avif',
          media,
          importance: 'high',
        }))
        .filter(({ href }) => href);

      preloader.set('server.preloadedAssets', PageModel, heroImageAssets);

      return preloader.load();
    });
  },
  decorator: decoratorParams(EdmundsTopRatedDecorator, { year, isDefaultYear }),
  component: () => <PageTemplate year={year} isDefaultYear={isDefaultYear} />,
  seo: (state, props) => {
    const contentPath = getTopRatedIndexContentPath(year);
    const content = parseContent(state.cms.content[contentPath]);

    return getTopRatedIndexSeoObject(content, props.location.pathname, year);
  },
});
